import { formateUTCDate } from '../libs/dates'
import * as types from './actionTypes'

export const createCreamItemAction = payload => ({
  type: types.CREATE_CREAM_ITEM,
  payload,
  /*
  "title": "團購名稱",
  "price": 500, // 購買金額 (每份)
  "qty": 3,     // 購買數量 (optional: 若不指定則不需此欄位)
  "deadline": "2020-03-28T15:59:59Z",  // 購買截止日期 (UTC) (optional: 若不指定則不需此欄位) date.toISOString
  "message": "感謝您的訂購",    // 付款畫面將會顯示的訊息 (optional: 若不指定則不需此欄位)
  "timezone": "Asia/Taipei" // Intl.DateTimeFormat().resolvedOptions().timeZone
   */
})

export const terminateCreamItemAction = itemId => ({
  type: types.TERMINATE_CREAM_ITEM,
  payload: itemId,
})

// export const getSlashInfoAction = () => ({ type: types.GET_SLASH_INFO })

/*
{
  type: 'MOVE_CREATED_ITEM_TO_LIST',
  payload: {
    cream_item_id: 'xxx',
    title: 'Test',
    instalment: 0,
    status: 'created',
    create_stamp: (new Date()).toISOString(),
    _created: true,
  }
}
 */
export const moveCreatedItemToListAction = createItemResponseData => ({
  type: types.MOVE_CREATED_ITEM_TO_LIST,
  payload: {
    cream_item_id: createItemResponseData.cream_item_id,
    title: createItemResponseData.title,
    instalment: createItemResponseData.instalment,
    receive_count: 0,
    status: 'created',
    create_stamp: formateUTCDate(new Date()),
    _created: true,
    _animated: false,
  },
})
